/** Coerce int/decimal panel values to Number before save (inputs are strings). */
export const serializeNumericValue = (value) => {
  if (value === '' || value === null || value === undefined) return '';
  const trimmed = typeof value === 'string' ? value.trim() : value;
  if (trimmed === '') return '';
  return Number(trimmed);
};

export const normalizeMoneyValue = (value, defaultCurrency = 'USD') => {
  if (value && typeof value === 'object') {
    return {
      value: value.value ?? '',
      currency: value.currency ?? defaultCurrency,
    };
  }
  return { value: value ?? '', currency: defaultCurrency };
};

export const serializeMoneyValue = ({ value, currency }) => {
  const numericValue = value === '' ? '' : Number(value);
  return { value: numericValue, currency };
};

export const normalizeLinkValue = (value) => {
  if (value && typeof value === 'object') {
    return {
      title: value.title ?? value.text ?? '',
      url: value.url ?? '',
    };
  }
  return { title: '', url: value ?? '' };
};

export const serializeLinkValue = ({ title, url }) => ({ title, url });

export const normalizeMediaValue = (value) => {
  if (value && typeof value === 'object') {
    return {
      name: value.name ?? '',
      url: value.url ?? '',
    };
  }
  return { name: '', url: value ?? '' };
};

export const serializeMediaValue = ({ name, url }) => {
  if (!name && !url) return '';
  return { name, url };
};

export const normalizeRatingValue = (value, defaultMax = 5) => {
  if (value && typeof value === 'object') {
    return {
      value: value.value ?? '',
      scale_max: value.scale_max ?? value.max ?? defaultMax,
    };
  }
  return { value: value ?? '', scale_max: defaultMax };
};

export const serializeRatingValue = ({ value, scale_max: scaleMax }) => ({
  value: value === '' ? '' : Number(value),
  scale_max: scaleMax,
});

export const normalizeMeasurementValue = (value, defaultUnit = '') => {
  if (value && typeof value === 'object') {
    return {
      value: value.value ?? '',
      unit: value.unit || defaultUnit,
    };
  }
  return { value: value ?? '', unit: defaultUnit };
};

export const serializeMeasurementValue = ({ value, unit }) => {
  const numericValue = value === '' ? '' : Number(value);
  return { value: numericValue, unit };
};

export const normalizeRichTextValue = (value) => {
  if (value && typeof value === 'object') {
    if (typeof value.value === 'string') return value.value;
    if (typeof value.text === 'string') return value.text;
    if (value.type === 'root' && Array.isArray(value.children)) {
      return shopifyRichTextJsonToHtml(value);
    }
  }

  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (trimmed.startsWith('{')) {
      try {
        const parsed = JSON.parse(trimmed);
        if (parsed?.type === 'root' && Array.isArray(parsed.children)) {
          return shopifyRichTextJsonToHtml(parsed);
        }
      } catch {
        // keep raw string
      }
    }
  }

  return value ?? '';
};

function shopifyRichTextJsonToHtml(root) {
  const renderNode = (node) => {
    if (!node || typeof node !== 'object') return '';

    if (node.type === 'text') {
      let text = String(node.value || '');
      if (node.bold) text = `<strong>${text}</strong>`;
      if (node.italic) text = `<em>${text}</em>`;
      return text;
    }

    if (node.type === 'link') {
      const inner = (node.children || []).map(renderNode).join('');
      const url = node.url || node.title || '';
      return url ? `<a href="${url}">${inner || url}</a>` : inner;
    }

    if (node.type === 'paragraph') {
      const inner = (node.children || []).map(renderNode).join('');
      return `<p>${inner}</p>`;
    }

    if (Array.isArray(node.children)) {
      return node.children.map(renderNode).join('');
    }

    return '';
  };

  return (root.children || []).map(renderNode).join('');
}

export const normalizeReferenceValue = (value) => {
  if (value && typeof value === 'object') {
    return value.id ?? value.value ?? '';
  }
  return value ?? '';
};

export const stringifyJsonValue = (value) => {
  if (value === null || value === undefined || value === '') return '';
  if (typeof value === 'string') return value;
  try {
    return JSON.stringify(value, null, 2);
  } catch (error) {
    return String(value);
  }
};

export const parseJsonValue = (rawValue) => {
  if (!rawValue) return '';
  try {
    return JSON.parse(rawValue);
  } catch (error) {
    return rawValue;
  }
};